// SubmenuItem.jsx
import React from "react";
import PropTypes from "prop-types";
import { ListItemIcon, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import StyledListItemButton from "./StyledListItemButton";

function SubmenuItem({ icon, color, primary, to }) {
  return (
    <StyledListItemButton component={Link} to={to} sx={{ width: "97%", ml: "4px" }}>
      <ListItemIcon>{React.cloneElement(icon, { sx: { color } })}</ListItemIcon>
      <ListItemText primary={primary} />
    </StyledListItemButton>
  );
}

SubmenuItem.propTypes = {
  icon: PropTypes.element.isRequired,
  color: PropTypes.string.isRequired,
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default SubmenuItem;
